import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppService } from 'src/app/core/services/app.service';
import { Router } from '@angular/router';
import { ExcelService } from 'src/app/core/services/excel.service';
import swal from 'sweetalert2';
import { Title } from '@angular/platform-browser';
import { LocalStorageService } from 'ngx-webstorage';

/*   EIA  2023   */
import { ToastrService } from 'ngx-toastr';
import { _CampagneService } from 'src/app/content/pages/campagne/campagne-module.service'
import { _EvaluationService } from '../../evaluation/evaluation.service';

/*   EIA  2023   */


@Component({
  selector: 'app-simulation',
  templateUrl: './simulation.component.html',
  encapsulation: ViewEncapsulation.None,
  styles: [`
    .dark-modal .modal-content {
      background-color: #292b2c;
      color: white;
    }
    .dark-modal .close {
      color: white;
    }
    .light-blue-backdrop {
      background-color: #5cb3fd;
    }
`]
})

export class SimulationComponent implements OnInit {

  public secondFilter: boolean = false
  public response: any
  public _categorie: any
  public _poste: any
  public _direction: any
  public _structure: any
  public _classification: any
  public nom_prenoms: string
  public matricule: string
  public campagne_id: any

  public listCategorie: any = [];
  public listPoste: any = [];
  public listDR: any = [];
  public listStructure: any = [];
  public listClassification: any = [];

  public loaderText: string;
  public listSimulation: any = [];
  public ficheSimulation = true;
  public date_debut: any;
  public date_fin: any;
  public libelle_campagne: string;
  public status_campagne: string;
  public nom: string;
  public prenoms: string;
   public key = 'campagne-eia';
  public reverse = false;
  public p = 1;
  public filter: string;
  sort(key) {
    this.key = key;
    this.reverse = !this.reverse;
  }
  constructor(
    private _router: Router,
    private _service: AppService,
    private title: Title,
    private _loader: LoadingBarService,
    private _excelService: ExcelService,
    private toastrService: ToastrService,
    private campagneSce: _CampagneService,
    private evaluationSce: _EvaluationService,
    private storage: LocalStorageService
  ) { }

  ngOnInit() {
    this.title.setTitle('Simulation | HR Performance');

    this.pageCallback();

    // Get all STRUCTURE
    this.campagneSce.GetAllStructure().subscribe((res) => this.listStructure = res.data);

    // Get all CLASSIFICATION
    this.campagneSce.getAllClassification({}).subscribe((res) => this.listClassification = res.data);

    // Get all CATEGORIE
    this.campagneSce.GetCategorie().subscribe((res) => this.listCategorie = res.data);

    // Get all POSTE
    this.campagneSce.GetPostes().subscribe((res) => this.listPoste = res.data);
  }

  /*  EIA  2023  */

  // Post all FILTER
  public filtr(): void {
    this.pageCallback()
  }

  public showSecondFilter(): void {
    this.secondFilter = !this.secondFilter;
  }

  public pageCallback(): void {
    const data = {
      categorie_id: this._categorie?.id,
      poste_id: this._poste?.id,
      structure_id: this._structure?.id,
      classification_id: this._classification?.id,
      nom_prenoms: this.nom_prenoms,
      matricule: this.matricule,
      campagne_id: this.storage.retrieve('idCampagneEiaSelected'),
    }
    this._loader.start();
    this.evaluationSce
      .GetCollaborateurs(data, this.p)
      .subscribe({
        next: (res: any) => {
          this._loader.stop();
          this.response = res.data;
          this.listSimulation = res.data.data;
          this.toastrService.success(res.message);
        },
        error: (error) => {
          this._loader.stop();
          this.toastrService.error(error.error.message);
        }
      })
  }

  public onPageChange(event) {
    this.p = event;
    this.pageCallback()
  }

  public onChangeItem(item: any, type: string, ) {
    if (type === 'direction') {
      return
    } else if (type === 'structure') {
      return;
    } else {
      return;
    }
  }

  public onClearItem(type: string) {
    if (type === 'direction') {
      this.listStructure = [];
    } else if (type === 'structure') {
      return;
    } else {
      return;
    }
  }

  public clearValue() {
    this._poste = "";
    this._categorie = "";
    this._structure = "";
    this._classification = "";
    this.nom_prenoms = "";
    this.matricule = "";
  }

  /*  EIA  2023  */

  exporterFiche() {
    this._loader.start();
    const arrayUtilisateurs = [];
    for (let i = 0; i < this.listSimulation?.length; i++) {
      arrayUtilisateurs.push(
        {
          'Matricule': this.listSimulation[i].matricule,
          'Nom': this.listSimulation[i].nom,
          'Prénoms': this.listSimulation[i].prenoms,
          'Poste': this.listSimulation[i].poste,
          'Classification': this.listSimulation[i].classification,
          'Catégorie': this.listSimulation[i].catégorie,
          'Statut': this.listSimulation[i].statut,
        }
      );
    }
    this._excelService.exportAsExcelFile(arrayUtilisateurs, 'liste_simulation');
    this._loader.stop();
  }

  voirSimulation(data, type_fiche, type_sauvegarde, category) {
    // tslint:disable-next-line: max-line-length
      this._router.navigateByUrl(`evaluation/moi/agent/${data?.id}/${data?.agent_id}/type_fiche/${type_fiche}/type_sauvegarde/${type_sauvegarde}/${category}/statut/${data?.statut}`);
  }


}
